import React from 'react';
import ServiceDetail from '../ServiceDetail';

// Dedicated page component for /services/cockroach-extermination
const RoachPage = () => <ServiceDetail slug="cockroach-extermination" />;

export default RoachPage;
